import type { FC, ReactChild } from 'react';
import React, { useMemo } from 'react';

import type { Node } from './../../ricos-schema/legacy/wix/rich_content/v1/index.js';
import type { NodeTreeMap } from './../../ricos-viewer-next/ContentViewer/utils/node-tree-traversal.js';
import { buildNodeTree } from './../../ricos-viewer-next/ContentViewer/utils/node-tree-traversal.js';

type NodeTreeMapContextProps = {
  nodes: Node[];
  children: ReactChild;
};

type ContextType = {
  nodeTreeMap: NodeTreeMap;
};

export const NodeTreeMapContext = React.createContext<ContextType>(null as unknown as ContextType);

export const NodeTreeMapContextProvider: FC<NodeTreeMapContextProps> = ({ nodes, children }) => {
  const nodeTreeMap = useMemo(() => {
    const { map } = buildNodeTree(nodes);
    return map;
  }, [nodes]);

  return (
    <NodeTreeMapContext.Provider value={{ nodeTreeMap }}>{children}</NodeTreeMapContext.Provider>
  );
};
